"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IlHolidayEventCardArgs = exports.IlHolidayEventCard = exports.IlEventCardRightIconArgs = exports.IlEventCardNoDescriptionArgs = exports.IlEventCardLeftIconArgs = exports.IlEventCardIconAvatarArgs = exports.IlEventCardDefaultArgs = exports.IlEventCardColorArgs = exports.IlEventCardAdornmentArgs = void 0;
var enums_1 = require("../../shared/enums");
var get_component_1 = require("../../shared/helpers/get-component");
var il_event_card_1 = require("./il-event-card");
var IlEventCardDefaultArgs = {
    title: 'Field trip!',
    description: 'Grand canyon school trip',
    avatar: 'RED',
};
exports.IlEventCardDefaultArgs = IlEventCardDefaultArgs;
var IlEventCardLeftIconArgs = __assign(__assign({}, IlEventCardDefaultArgs), { avatar: undefined, leftIcon: enums_1.IconEnum.PERSON_SWIMMING });
exports.IlEventCardLeftIconArgs = IlEventCardLeftIconArgs;
var IlEventCardRightIconArgs = __assign(__assign({}, IlEventCardDefaultArgs), { avatar: undefined, rightIcon: enums_1.IconEnum.PERSON_SWIMMING });
exports.IlEventCardRightIconArgs = IlEventCardRightIconArgs;
var IlEventCardIconAvatarArgs = __assign(__assign({}, IlEventCardDefaultArgs), { rightIcon: enums_1.IconEnum.PERSON_SWIMMING });
exports.IlEventCardIconAvatarArgs = IlEventCardIconAvatarArgs;
var IlEventCardColorArgs = __assign(__assign({}, IlEventCardDefaultArgs), { color: '#ffad00' });
exports.IlEventCardColorArgs = IlEventCardColorArgs;
var IlEventCardNoDescriptionArgs = __assign(__assign({}, IlEventCardDefaultArgs), { description: undefined });
exports.IlEventCardNoDescriptionArgs = IlEventCardNoDescriptionArgs;
var IlHolidayEventCardArgs = {
    title: 'Holiday!',
    description: 'Not a school day',
    avatar: undefined,
    leftIcon: enums_1.IconEnum.CALENDAR_MINUS_REGULAR,
    color: '#6C5CE5',
    sx: {
        height: '1.5rem',
        '.event-description': { fontSize: '0.875rem', fontWeight: 600 },
    },
};
exports.IlHolidayEventCardArgs = IlHolidayEventCardArgs;
var IlEventCardAdornmentArgs = {
    title: 'Holiday!',
    description: 'Not a school day',
    avatar: undefined,
    leftIcon: enums_1.IconEnum.CALENDAR_MINUS_REGULAR,
    color: '#6C5CE5',
    adornmentRightIcon: enums_1.IconEnum.TIME_OFF,
    sx: {
        height: '1.5rem',
        '.event-description': { fontSize: '0.875rem', fontWeight: 600 },
    },
};
exports.IlEventCardAdornmentArgs = IlEventCardAdornmentArgs;
var IlHolidayEventCard = (0, get_component_1.getComponent)(il_event_card_1.ILEventCard, IlHolidayEventCardArgs);
exports.IlHolidayEventCard = IlHolidayEventCard;
